'use client';

import type { ReactNode } from 'react';
import { AnswerProvider } from './answer/Context';

type GlobalProvidersProps = {
  children: ReactNode;
};

/** Layout-scoped providers (answers persist across step pages). */
export function GlobalProviders({ children }: GlobalProvidersProps) {
  return <AnswerProvider>{children}</AnswerProvider>;
}
